import LocationUsersList from "app/features/locations/templates/LocationUsersList";

export default function LocationPage() {
  return <LocationUsersList />;
}
